var _regeneratorRuntime = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var _classCallCheck = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _require = require('factom'),
    FactomCli = _require.FactomCli;

var coinbaseAdress = require('./coinbase-address');

var eff = require('./efficiency');

var coinbaseCancel = require('./coinbase-cancel');

var getServer = require('./get');
/**
 * Main class to read and write Factom identities.
 * @memberof server
 * @param {Object} [opts] - Options of connection to factomd and factom-walletd.
 * @param {Object} [opts.factomd] - Options of connection to factomd. See {@link https://factomjs.luciap.ca/#connectionoptions}.
 * @param {Object} [opts.walletd] - Options of connection to factom-walletd. See {@link https://factomjs.luciap.ca/#connectionoptions}.
 * @example
 * const manager = new FactomServerIdentityManager({
 *      factomd: {
 *          host: 'api.factomd.net',
 *          port: 443,
 *          protocol: 'https'
 *      },
 *      walletd: {
 *          host: 'localhost',
 *          user: 'paul',
 *          password: 'pass'
 *      }
 * });
 */


var FactomServerIdentityManager =
/*#__PURE__*/
function () {
  "use strict";

  function FactomServerIdentityManager(opts) {
    _classCallCheck(this, FactomServerIdentityManager);

    this.cli = new FactomCli(opts);
  }
  /**
   * Get a server identity information.
   * @async
   * @param {string} rootChainId - Identity Root Chain Id.
   * @returns {{rootChainId: string, serverManagementSubchainId: string, coinbaseAddress: string, efficiency: number, identityKeys: string[]}}
   */


  _createClass(FactomServerIdentityManager, [{
    key: "getServerIdentity",
    value: function () {
      var _getServerIdentity = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(rootChainId) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", getServer.getIdentity(this.cli, rootChainId));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getServerIdentity(_x) {
        return _getServerIdentity.apply(this, arguments);
      }

      return getServerIdentity;
    }()
    /**
     * Get a server identity information history.
     * @async
     * @param {string} rootChainId - Identity Root Chain Id.
     * @returns {{rootChainId: string, serverManagementSubchainId: string, coinbaseAddressHistory: Object[], efficiencyHistory: Object[], identityKeys: string[]}}
     */

  }, {
    key: "getServerIdentityHistory",
    value: function () {
      var _getServerIdentityHistory = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(rootChainId) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", getServer.getIdentityHistory(this.cli, rootChainId));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getServerIdentityHistory(_x2) {
        return _getServerIdentityHistory.apply(this, arguments);
      }

      return getServerIdentityHistory;
    }()
    /**
     * Update the coinbase address of a server identity.
     * @param {string} rootChainId - Identity Root Chain Id.
     * @param {string} fctAddress - Public Factoid address to set as coinbase address.
     * @param {string} sk1 - Server identity Secret Key 1.
     * @param {string} ecAddress - Entry Credit address paying for the entry.
     * @returns {{ txId: string, repeatedCommit: boolean, chainId: string, entryHash: string }} - Info about the Entry insertion.
     */

  }, {
    key: "updateCoinbaseAddress",
    value: function () {
      var _updateCoinbaseAddress = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(rootChainId, fctAddress, sk1, ecAddress) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", coinbaseAdress.update(this.cli, rootChainId, fctAddress, sk1, ecAddress));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function updateCoinbaseAddress(_x3, _x4, _x5, _x6) {
        return _updateCoinbaseAddress.apply(this, arguments);
      }

      return updateCoinbaseAddress;
    }()
    /**
     * Update the efficiency of a server identity.
     * @param {string} rootChainId - Identity Root Chain Id.
     * @param {number} efficiency - Efficiency between 0 and 100.
     * @param {string} sk1 - Server identity Secret Key 1.
     * @param {string} ecAddress - Entry Credit address paying for the entry.
     * @returns {{ txId: string, repeatedCommit: boolean, chainId: string, entryHash: string }} - Info about the Entry insertion.
     */

  }, {
    key: "updateEfficiency",
    value: function () {
      var _updateEfficiency = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(rootChainId, efficiency, sk1, ecAddress) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", eff.update(this.cli, rootChainId, efficiency, sk1, ecAddress));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function updateEfficiency(_x7, _x8, _x9, _x10) {
        return _updateEfficiency.apply(this, arguments);
      }

      return updateEfficiency;
    }()
    /**
     * Add a coinbase cancel message to a server identity.
     * @param {string} rootChainId - Identity Root Chain Id.
     * @param {number} descriptorHeight - Coinbase descriptor block height.
     * @param {number} descriptorIndex - Coinbase descriptor index.
     * @param {string} sk1 - Server identity Secret Key 1.
     * @param {string} ecAddress - Entry Credit address paying for the entry.
     * @returns {{ txId: string, repeatedCommit: boolean, chainId: string, entryHash: string }} - Info about the Entry insertion.
     */

  }, {
    key: "addCoinbaseCancel",
    value: function () {
      var _addCoinbaseCancel = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(rootChainId, descriptorHeight, descriptorIndex, sk1, ecAddress) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", coinbaseCancel.add(this.cli, rootChainId, descriptorHeight, descriptorIndex, sk1, ecAddress));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function addCoinbaseCancel(_x11, _x12, _x13, _x14, _x15) {
        return _addCoinbaseCancel.apply(this, arguments);
      }

      return addCoinbaseCancel;
    }()
  }]);

  return FactomServerIdentityManager;
}();

module.exports = {
  FactomServerIdentityManager: FactomServerIdentityManager
};